import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from "rxjs/Observable";
import { ErrorHandler } from '../../globals/classes/errorHandler';
import { Extensions } from '../classes/static/extensions';

@Injectable()
export class ParamsGuardService implements CanActivate {
    constructor(private router: Router) { }

    canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (Extensions.getReturnUrl(childRoute.queryParams) === undefined && (Extensions.returnUrl === undefined || Extensions.returnUrl.length == 0)) {
            ErrorHandler.newError(undefined);
            return false;
        }
        else {
            return true;
        }
    }
}